import {supportsLightDark, Document} from "@cdx/common";
import {useEffect} from "react";
import confirm from "./confirm";
import {singleKeySessionStorage} from "./storage";

export const useBrowserCheck = () => {
  useEffect(() => {
    if (!supportsLightDark()) {
      const storage = singleKeySessionStorage("browser-support-light-dark");
      if (storage.get()) return;
      void confirm({
        title: "Browser Update needed",
        content: (
          <Document>
            <p>
              Your browser is out of date. Please upgrade to one of the{" "}
              <a
                href="https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/light-dark#browser_compatibility"
                target="_blank"
                rel="noopener noreferrer"
              >
                supported versions
              </a>
            </p>
            <p>Otherwise Codecks may not look or behave as intended.</p>
          </Document>
        ),
        confirmLabel: "Understood",
        cancelLabel: null,
      }).then(() => storage.set(true));
    }
  }, []);
};
